<template>
	<div class="Box">
		<!-- <div class="Menu">
			<ul>
				<li class="menuText" @click="Menuscroll(1)">SHOWREEL</li>
				<li class="menuText" @click="Menuscroll(2)">电影</li>
				<li class="menuText" @click="Menuscroll(3)">电视剧</li>
				<li class="menuText" @click="Menuscroll(4)">网络剧</li>
				<li class="menuText" @click="Menuscroll(5)">网络大电影</li>
			</ul>
		</div> -->
		<!-- 作品展示 -->
		<div  class="showreelHeight">
			<div class="title">
				<div class="bgimg">
					<img src="../assets/img/ww01.png" alt="">
				</div>
				<div class="text"  @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
					<p class="name">作品展示</p>
					<p class="english">SHOWREEL</p>
					<p class="det">
						<span style="margin-right: 0.3rem;" :class="['redspan',{year:videoIndex==index}]" v-for="(item,index) in videoWork"
						 :key="index" :data-index=index @click="videoName($event)">
							{{item.name}}
						</span>
					</p>
				</div>
			</div>
			<div style="width: 100%; height: 7.15rem; background-color: #0F0F0F;">
				<div class="videoOne" v-for="(item,index) in videoWork" :key="index" v-if="videoIndex==index">
					<video :src="item.pic" :poster="item.englishName"></video>
				<!-- 	<div class="videoOne" v-for="(item,index) in text" :key="index" v-if="videoIndex==index">
					<video :src="item.pic" :poster="item.englishName"></video> -->
					<div v-if="videoIcon" class="videoIcon" @click="play()"><img src="../assets/img/video.png" alt=""></div>
				</div>
			</div>
		</div>
		<!-- 电影作品 -->
		<div class="filmHeight" id="myfilm" name="myfilm" ref="myfilm">
			<div class="title">
				<div class="bgimg">
					<img src="../assets/img/ww02.png" alt="">
				</div>
				<div class="text"  @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
					<p class="name">电影作品</p>
					<p class="english">FILM</p>
				</div>
			</div>
			<div class="workBox">
				<div class="trans">
					<swiper ref="mySwiper" :options="swiperOptionTwo" class="banner">
						<swiper-slide v-for="item in film">
							<div class="trans_li">
								<div class="trans_img">
									<img :src="item.pic" alt="">
								</div>
								<div class="trans_name">{{item.name}}</div>
							</div>
						</swiper-slide>
					</swiper>
					<div class="btn left left2"><img src="../assets/img/left.png"></div>
					<div class="btn right right2"><img src="../assets/img/right.png"></div>
				</div>
			</div>
		</div>
		<!-- 电视剧作品 -->
		<div id="mytv" name="mytv" ref="mytv" class="tvHeight">
			<div class="title">
				<div class="bgimg">
					<img src="../assets/img/ww03.png" alt="">
				</div>
				<div class="text"  @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
					<p class="name">电视剧</p>
					<p class="english">TV SERIES</p>
				</div>
			</div>
			<div class="workBox">
				<div class="trans">
					<swiper ref="mySwiper" :options="swiperOptionOne" class="banner">
						<swiper-slide v-for="item in tv">
							<div class="trans_li">
								<div class="trans_img">
									<img :src="item.pic" alt="">
								</div>
								<div class="trans_name">{{item.name}}</div>
							</div>
						</swiper-slide>
					</swiper>
					<div class="btn left left1"><img src="../assets/img/left.png"></div>
					<div class="btn right right1"><img src="../assets/img/right.png"></div>
				</div>
			</div>
		</div>

		<!-- 网络剧作品 -->
		<div class="teleHeight">
			<div class="title">
				<div class="bgimg">
					<img src="../assets/img/ww04.png" alt="">
				</div>
				<div class="text"  @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
					<p class="name">网络剧</p>
					<p class="english">WEB DRAMA</p>
				</div>
			</div>
			<div class="workBox">
				<div class="trans">
					<swiper ref="mySwiper" :options="swiperOptionThree" class="banner">
						<swiper-slide v-for="item in teleplay">
							<div class="trans_li">
								<div class="trans_img">
									<img :src="item.pic" alt="">
								</div>
								<div class="trans_name">{{item.name}}</div>
							</div>
						</swiper-slide>
					</swiper>
					<div class="btn left left3"><img src="../assets/img/left.png"></div>
					<div class="btn right right3"><img src="../assets/img/right.png"></div>
				</div>
			</div>
		</div>
		<!-- 网络电影作品 -->
		<div class="telefilmHeight">
			<div class="title">
				<div class="bgimg">
					<img src="../assets/img/ww05.png" alt="">
				</div>
				<div class="text"  @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
					<p class="name">网络大电影</p>
					<p class="english">WEB MOVIES</p>
				</div>
			</div>
			<div class="workBox">
				<div class="trans">
					<swiper ref="mySwiper" :options="swiperOptionFour" class="banner">
						<swiper-slide v-for="item in telefilm">
							<div class="trans_li">
								<div class="trans_img">
									<img :src="item.pic" alt="">
								</div>
								<div class="trans_name">{{item.name}}</div>
							</div>
						</swiper-slide>
					</swiper>
					<div class="btn left left4"><img src="../assets/img/left.png"></div>
					<div class="btn right right4"><img src="../assets/img/right.png"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Swiper,
		SwiperSlide,
		directive
	} from 'vue-awesome-swiper'
	export default {
		name: 'work',
		components: {
			Swiper,
			SwiperSlide
		},
		directives: {
			swiper: directive
		},
		data() {
			return {
				swiperOptions: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right',
						prevEl: '.left',
					},
				},
				swiperOptionOne: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right1',
						prevEl: '.left1',
					},
					slidesPerView: 4, //页面可视数（网格）
				},
				swiperOptionTwo: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right2',
						prevEl: '.left2',
					},
					slidesPerView: 4, //页面可视数（网格）
				},
				swiperOptionThree: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right3',
						prevEl: '.left3',
					},
					slidesPerView: 4, //页面可视数（网格）
				},
				swiperOptionFour: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right4',
						prevEl: '.left4',
					},
					slidesPerView: 4, //页面可视数（网格）
				},
				publicity: "", //视频链接
				videoIcon: true,
				film: "",
				tv: "",
				telefilm: "",
				teleplay: "",
				videoWork: [], //视频作品
				hot: 1,
				videoIndex: 0,
				queryNum: "", //监听当前路由是否发生变化
				showreelHeight:"",
				filmHeight: "",
				tvHeight: "",
				teleHeight: "",
				telefilmHeight: "",
				/* text:[
					{"pic":"https://aliyuncdn.kmjiu.com/videos/0904/56zXeQzTx2.mp4","englishName":"https://aliyuncdn.kmjiu.com/images/0522/1590117575518.jpg"},
					{"pic":"https://aliyuncdn.kmjiu.com/videos/0908/a2zXwe6Ckd.mov","englishName":"https://aliyuncdn.kmjiu.com/images/0602/1591094468184.jpg"},
					{"pic":"https://aliyuncdn.kmjiu.com/videos/0816/t2xw683Qsp.mp4","englishName":"https://aliyuncdn.kmjiu.com/images/0522/1590117575518.jpg"},
					{"pic":"https://aliyuncdn.kmjiu.com/videos/0904/fyBhK7PmhQ.mp4","englishName":"https://aliyuncdn.kmjiu.com/images/0602/1591094468184.jpg"}] */
			}
		},
		watch: {
			$route: {
				handler() {
					this.queryNum = this.$route.query.num;
					// this.getDetail();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
			queryNum(newValue, old) {
				if (newValue != old) {
					console.log("页面的值由" + old + "变为" + newValue)
					if(newValue == 30){
						this.scroll0()
					}else if (newValue == 31) {
						this.scroll1()
					} else if (newValue == 32) {
						this.scroll2()
					} else if (newValue == 33) {
						this.scroll3()
					} else if (newValue == 34) {
						this.scroll4()
					}
				}
			}
		},
		methods: {
			//鼠标移入标题
			titleEnter(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1.1,1.1)'
				bgimg.style.transitionDuration="1s"
			},
			//鼠标移出标题
			titleLeave(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1,1)'
				bgimg.style.transitionDuration="1s"
			},
			//切换选项卡
			videoName(e) {
				console.log(e.currentTarget)
				console.log(e.target.dataset.index)
				this.videoIndex = e.target.dataset.index
				let video = document.querySelector('video')
				console.log("切换的视频",video)
				 video.pause()
				 this.videoIcon = true;
				
			},
			//获取作品
			getOther() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 1
				}).then(res => {
					this.videoWork = res.data.data
					console.log("视频作品", res.data.data)
				}).catch(err => {})
			},
			//点击播放
			play() {
				let video = document.querySelector('video')
				video.play();
				video.controls = "controls";
				this.videoIcon = false;
				let _this = this;
				video.addEventListener('ended', function() { //播放开始执行的函数
					console.log("停止播放")
					video.controls = "";
					_this.videoIcon = true;
				});
			},
			//切换选项卡的时候停止播放
			stop(num) {
				let video = document.querySelector('video')
				video.addEventListener('ended', function() { //播放开始执行的函数
					// console.log("停止播放")
					video.controls = "";
					_this.videoIcon = true;
				});
				// console.log("停止播放",video)
				this.hot = num
			},
			//获取电影信息列表
			getFilmCategory() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 2,
					offset: 0,
					limit: 8
				}).then(res => {
					// console.log("获取电影分类", res.data);
					this.film = res.data.data
					this.scroll1();
				}).catch(err => {})
			},
			//获取电视剧信息列表
			geTvCategory() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 3,
					offset: 0,
					limit: 8
				}).then(res => {
					// console.log("获取电视剧分类", res.data);
					this.tv = res.data.data
					this.scroll2();
				}).catch(err => {})
			},
			//获取网剧信息列表
			getTeleplayCategory() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 5,
					offset: 0,
					limit: 8
				}).then(res => {
					// console.log("获取网剧分类", res.data);
					this.teleplay = res.data.data
					this.scroll3();
				}).catch(err => {})
			},
			//获取网络电影信息列表
			getTeleFilmCategory() {
				this.$api.get(this.$httpApi + this.$path.INDEX_MOVIELIST, {
					type: 4,
					offset: 0,
					limit: 8
				}).then(res => {
					// console.log("获取网络电影分类", res.data);
					this.telefilm = res.data.data;
					this.scroll4();
				}).catch(err => {})
			},

			//锚点跳转
			jump() {
				var hash = window.location.hash;
				var index = hash.lastIndexOf("#");
				if (index != -1) {
					var id = hash.substring(index + 1, hash.length + 1);
					var div = document.getElementById(id);

					if (div) {
						setTimeout(function() {
							console.log("haxi高度", $(div).offset().top);
							let height = $(div).offset().top
							document.body.scrollTop = height
							document.documentElement.scrollTop = height
							//$('html,body').scrollTop($(div).offset().top - 43);
							// scrollTop: $(div).offset().top
							// $('html, body').animate({scrollTop: $(div).offset().top}, 500)
						}, 50);
					}
				}
			},
			//页面滚动到指定位置
			//滚动到SHOWREEL的高度
			scroll0() {
				this.$nextTick(() => {
					//获取高度
					let showreelHeight = document.querySelector('.showreelHeight')
					this.showreelHeight = showreelHeight.offsetTop
					console.log("我可以獲取到高度嗎",this.showreelHeight)
					//设置高度
					if (this.$route.query.num == 30) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.showreelHeight
							document.documentElement.scrollTop = _this.showreelHeight
						}, 100);
					}
				})
			},
			//滚动到电影的高度
			scroll1() {
				this.$nextTick(() => {
					//获取高度
					let filmHeight = document.querySelector('.filmHeight')
					this.filmHeight = filmHeight.offsetTop
					//设置高度
					if (this.$route.query.num == 31) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.filmHeight
							document.documentElement.scrollTop = _this.filmHeight
						}, 100);
					}
				})
			},
			//滚动到电视剧的高度
			scroll2() {
				this.$nextTick(() => {
					//获取高度
					let tvHeight = document.querySelector('.tvHeight')
					this.tvHeight = tvHeight.offsetTop
					//设置高度
					if (this.$route.query.num == 32) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.tvHeight
							document.documentElement.scrollTop = _this.tvHeight
						}, 100);
					}
				})
			},
			//滚动到网络剧的高度
			scroll3() {
				this.$nextTick(() => {
					//获取高度
					let teleHeight = document.querySelector('.teleHeight')
					this.teleHeight = teleHeight.offsetTop
					//设置高度
					if (this.$route.query.num == 33) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.teleHeight
							document.documentElement.scrollTop = _this.teleHeight
						}, 100);
					}
				})
			},
			//滚动到网络电影的高度
			scroll4() {
				this.$nextTick(() => {
					//获取高度
					let telefilmHeight = document.querySelector('.telefilmHeight')
					this.telefilmHeight = telefilmHeight.offsetTop
					//设置高度
					if (this.$route.query.num == 34) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.telefilmHeight
							document.documentElement.scrollTop = _this.telefilmHeight
						}, 100);
					}
				})
			},
			//横板菜单全部滚动到固定位置(否)
			Menuscroll(value){
				if(value==1){
					let showreelHeight = document.querySelector('.showreelHeight')
					this.showreelHeight = showreelHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.showreelHeight
					document.documentElement.scrollTop = this.showreelHeight
				}else if(value==2){
					//获取高度
					let filmHeight = document.querySelector('.filmHeight')
					this.filmHeight = filmHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.filmHeight
					document.documentElement.scrollTop = this.filmHeight
				}else if(value==3){
					//获取高度
					let tvHeight = document.querySelector('.tvHeight')
					this.tvHeight = tvHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.tvHeight
					document.documentElement.scrollTop = this.tvHeight
				}else if(value==4){
					//获取高度
					let teleHeight = document.querySelector('.teleHeight')
					this.teleHeight = teleHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.teleHeight
					document.documentElement.scrollTop = this.teleHeight
				}else if(value==5){
					//获取高度
					let telefilmHeight = document.querySelector('.telefilmHeight')
					this.telefilmHeight = telefilmHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.telefilmHeight
					document.documentElement.scrollTop = this.telefilmHeight
				}
			},
		},
		mounted() {
			this.getOther();
			this.getFilmCategory();
			this.geTvCategory()
			this.getTeleFilmCategory()
			this.getTeleplayCategory()
			// this.jump()
		}
	}
</script>

<style scoped>
	.Box {
		width: 19.20rem;
		height: auto;
	}
	/* 菜单 */
    .Menu {
    	width: 100%;
    	height: 0.4rem;
    	background-color: #05060a;
    	line-height: 0.20rem;
    	padding-left: 5.10rem;
    	box-sizing: border-box;
    }
    .menuText{
    	color: #ffffff;
    	font-size: 0.18rem;
    	float: left;
    	margin-right: 1rem;
		cursor: pointer;
    } 
	/* 标题开始 */
	.title {
		width: 100%;
		height: 2.40rem;
		padding: 0 1.32rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		position: relative;
		border-bottom: 0.01rem solid #666666;
	}

	.bgimg {
		width: 1.86rem;
		height: 1.5rem;
		position: absolute;
		left: 1.32rem;
		top: 0.4rem;
	}

	.bgimg img {
		/* width: 100%; */
		height: 100%;
	}

	.text {
		min-width: 6.80rem;
		height: 2.00rem;
		position: absolute;
		left: 1.4rem;
		top: 0.20rem;
		z-index: 2;
	}
    .text:hover{
		cursor: pointer;
		color: #7e0e0f;
	}
	.name {
		color: #FFFFFF;
		font-size: 0.32rem;
		text-align: left;
		margin-top: 0.60rem;
		line-height: 0.50rem;
		font-weight: 500;
		letter-spacing: 0.04rem;
	}

	.english {
		color: #FFFFFF;
		font-size: 0.21rem;
		line-height: 0.30rem;
		font-weight: 500;
		text-align: left;
		letter-spacing: 0.02rem;
	}

	.det {
		color: #d5d5d5;
		font-weight: 600;
		font-size: 0.24rem;
		line-height: 0.20rem;
		cursor: pointer;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.detspan {
		margin-right: 0.3rems;
		position: relative;
	}
	.redspan:hover{
		color: #7e0e0f;
	}
   
	.redspan::after {
		content: '-';
		position: relative;
		right: -0.14rem;
	}

	.redspan:last-child::after {
		content: '';
	}

	.year {
		color: #7e0e0f;
		font-weight: 600;
	}

	/* 标题结束 */
	.videoOne,
	.videoTwo,
	.videoThree,
	.videoFour {
		width: 100%;
		height: 7.15rem;
		background-color: #0F0F0F;
		/* background-color: #ff55ff; */
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: 0.01rem solid #666666;
		position: relative;
		padding: 0.44rem 1.45rem;
		box-sizing: border-box;
	}

	video {
		width: 100%;
		height: 6.26rem;
		/* background-color: #0000CD; */
		padding: 0;
		margin: 0;

	}

	.videoIcon {
		width: 1.25rem;
		height: 1.25rem;
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	.videoIcon img {
		width: 100%;
		height: 100%;
	}

	.workBox {
		width: 100%;
		height: 7.15rem;
		background-color: #0F0F0F;
		padding: 0.70rem 1.34rem;
		box-sizing: border-box;
		border-bottom: 0.01rem solid #666666;
	}

	/* 作品轮播 */
	.trans {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.banner {
		width: 15.30rem;
		height: 100%;
	}

	.btn {
		width: 0.30rem;
		height: 0.56rem;
		outline: none;
		position: absolute;
		cursor: pointer;
	}

	.left {
		position: absolute;
		left: 0;
		top: 1.85rem;
	}

	.right {
		position: absolute;
		right: 0;
		top: 1.85rem;
	}

	.left>img,
	.right>img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.trans_li {
		width: 3.10rem;
		height: 100%;
		/* float: left; */
		margin-right: 0.86rem;
	}

	.trans_li:last-child {
		margin: 0;
	}

	.trans_img {
		width: 100%;
		height: 4.60rem;
	}

	.trans_img img {
		width: 100%;
		height: 100%;
	}

	.trans_name {
		width: 100%;
		height: 0.24rem;
		margin-top: 0.60rem;
		text-align: center;
		color: #FFFFFF;
		font-size: 0.2rem;
		font-weight: 600;
		line-height: 0.24rem;
		letter-spacing: 0.02rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/work.vue